import { useSyncExternalStore } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { SESSION_EXPIRED_EVENT, isAuthenticated } from "@/lib/auth";

/** Re-render the guard when the session ends — either here (a refresh the
 *  server rejected) or in another tab (a `storage` write). Checking only on
 *  navigation would leave the user parked on a shell where every poll raises
 *  a "session expired" toast and nothing ever recovers. */
function subscribe(onChange: () => void): () => void {
  window.addEventListener(SESSION_EXPIRED_EVENT, onChange);
  window.addEventListener("storage", onChange);
  return () => {
    window.removeEventListener(SESSION_EXPIRED_EVENT, onChange);
    window.removeEventListener("storage", onChange);
  };
}

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const authed = useSyncExternalStore(subscribe, isAuthenticated, () => false);
  if (!authed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
